import { render, staticRenderFns } from "./BTablePublicationStorageFilesHistory.vue?vue&type=template&id=3f8a9452&"
import script from "./BTablePublicationStorageFilesHistory.vue?vue&type=script&lang=js&"
export * from "./BTablePublicationStorageFilesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports